// extracted by mini-css-extract-plugin
export default {"button":"add-new-page-button-module__button--FTg2c","container":"add-new-page-button-module__container--Qq6Mi","tooltip":"add-new-page-button-module__tooltip--MWDtt"};